/**
 * Return the origin of an url
 *
 * @param document The reference to the document object
 * @param url The ´url´ for which to get the 'origin'
 * @returns A string representing the url origin
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getUrlOrigin(document, url) {
    if (!url)
        return '';
    var a = document.createElement('a');
    a.setAttribute('href', url);
    return a.protocol + '//' + a.hostname + (a.port && ':' + a.port);
}
export { getUrlOrigin };
//# sourceMappingURL=getUrlOrigin.js.map